import type { RiskListOptimizedResponse } from '@risksmart-app/drizzle/src/dto';
import type { GetRiskListOptimizedQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetRiskListOptimizedDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

export const useGetRiskListOptimized = createQueryHook<
  Record<string, never>,
  RiskListOptimizedResponse,
  GetRiskListOptimizedQuery
>({
  trpcQueryOptions: (trpc) =>
    trpc.frontend.risk.riskListOptimized.queryOptions(),
  mapTrpcDataToGraphQL: (data) => ({
    risk: data.risk,
    node: data.node,
  }),
  graphqlDocument: GetRiskListOptimizedDocument,
});
